import { orderStyles } from 'views/Orders/styles';
import Addresses from 'views/Clients/FormTabs/Addresses/List';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Close from '@material-ui/icons/Close';
import ModalButton from 'components/CustomButtons/Button';

type DietDetailsAddressProps = {
  addressesModalStatus: boolean;
  closeModal: () => void;
  client: {
    id: number;
  };
};

const DietDetailsAddress = ({
  addressesModalStatus,
  closeModal,
  client,
}: DietDetailsAddressProps) => (
  <Dialog
    maxWidth="lg"
    fullWidth={true}
    open={addressesModalStatus}
    onClose={closeModal}
  >
    <DialogContent>
      <ModalButton
        style={orderStyles.closeButton}
        color="transparent"
        justIcon={true}
        round={true}
        onClick={closeModal}
      >
        <Close />
      </ModalButton>
      <Addresses noCancel={true} userId={client.id} isChangeUrlLoader={false} />
    </DialogContent>
  </Dialog>
);

export default DietDetailsAddress;
